<template>
    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         width="510px" height="510px" viewBox="0 0 510 510" style="enable-background:new 0 0 510 510;" xml:space="preserve">
    <g>
        <g id="event">
            <path d="M382.5,280.5H255V408h127.5V280.5z M357,0v51H153V0h-51v51H76.5c-28.05,0-51,22.95-51,51v357c0,28.05,22.95,51,51,51h357
            c28.05,0,51-22.95,51-51V102c0-28.05-22.95-51-51-51H408V0H357z M433.5,459h-357V178.5h357V459z"/>
        </g>
    </g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
</template>

<script>
export default {
  name: 'IconCalendarFilters'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/icons/IconCalendarFilters.vue